import { Link } from "react-router-dom";
import VeevaConfigForm from "./VeevaConfigForm";
import { CREATE_VEEVA_CONFIG } from "./query";

const CreateVeevaConfig = () => {
    return (
        <div className="custom-shadow p-5">
            <Link
                to="/global-config/abbvie-id/veeva-config"
                className="btn btn-outline-primary mb-5"
            >
                Back
            </Link>
            <h3 className="mb-5">Create Veeva Config</h3>

            <VeevaConfigForm query={CREATE_VEEVA_CONFIG} />
        </div>
    );
};

export default CreateVeevaConfig;
